import { useEffect, useState } from "react";

/**
 * The value as it stood `delayMs` ago, updated once typing pauses.
 *
 * The directory picker searches on this rather than on every keystroke: the
 * service bounds and pages every search, but a request per character is still
 * a request per character, and the answer to "Ta" is not worth waiting for
 * when "Tamar" is a moment away.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
